import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=5b930036&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&id=5b930036&lang=scss&scoped=true&"
import style1 from "./channel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b930036",
  null
  
)

export default component.exports